import React, { useState, useEffect } from 'react';

import axios from 'axios';
import dayjs from "dayjs";
import ModalLoad from '../../../components/modal/ModalLoad.js';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';
import Calendar from '../../../components/calendar/Calendar.js';

function SubAdminMeterReverse(props) {
    const [reportsite, setReportsite] = useState('P3-01');
    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));

    const [data_list, setData_list] = useState({
        list: [],
        total_meter: 1
    });

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })

    useEffect(() => {
        return () => {
            setData_list({
                list: [],
                total_meter: 1
            })
        }
    }, []);

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const onCalendaraChange = (date, dateString) => {
        setReportdate_dt(date)
    };
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(confirmcode) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    async function api_query_meter5m() {
        setmodal_load({ enable: true, message: "Loading meter calculation from database." })
        await sleep(500)

        const formData = new FormData()
        formData.append('reportsite', reportsite)
        formData.append('reportdate', dayjs(new Date(reportdate_dt)).format("YYYY-MM"))

        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/historical/advanced/meterreverse", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.data !== null && response.data.data !== undefined) {
                        setData_list(response.data.data)
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setData_list({
                    list: [],
                    total_meter: 1
                })
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-th-large"></i> Meter Reverse</h4>
                                    <p className="mb-0">tracking your solar meter reversed accumulate.</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                                <div className="d-block">
                                    <label htmlFor="reportsite" className="form-label mb-0">Select Site</label>
                                    <select id="reportsite" name="reportsite" className="form-select font-sarabun" value={reportsite} onChange={(e) => {
                                        setReportsite(e.target.value)
                                    }} required>
                                        {
                                            props.permitdata !== null ?
                                                props.permitdata?.sitescope_arr?.map((data, index) => (
                                                    <option value={data.sitecode_txt} key={data.sitecode_txt}>{data.sitecode_txt} {data.sitename_th}</option>
                                                ))
                                                :
                                                null
                                        }
                                    </select>
                                </div>
                                <div className="d-block " style={{ width: "160px" }}>
                                    <label htmlFor="reporttype" className="form-label mb-0">Select Date</label>
                                    <Calendar
                                        allowClear={false}
                                        className={"form-control"}
                                        onChange={onCalendaraChange}
                                        picker={"month"}
                                        style={{
                                            fontFamily: "poppins",
                                            fontSize: "0.75rem",
                                            Color: "black",
                                            lineHeight: "1.5",
                                            cursor: "pointer",
                                        }}
                                        value={reportdate_dt}
                                    />
                                </div>
                                <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                                    <button className="btn btn-info btn-sm me-5" onClick={() => { api_query_meter5m() }}><i className="fas fa-search me-2"></i> Query</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th rowSpan={2}>Timestamp</th>
                                        <th colSpan={2}>Solar #1</th>
                                        {data_list?.total_meter > 1 ? <th colSpan={2}>Solar #2</th> : null}
                                        {data_list?.total_meter > 2 ? <th colSpan={2}>Solar #3</th> : null}
                                    </tr>
                                    <tr className="admintable-header">
                                        <th>Import ACC.</th>
                                        <th>Export ACC.</th>
                                        {data_list?.total_meter > 1 ? <th>Import ACC.</th> : null}
                                        {data_list?.total_meter > 1 ? <th>Export ACC.</th> : null}
                                        {data_list?.total_meter > 2 ? <th>Import ACC.</th> : null}
                                        {data_list?.total_meter > 2 ? <th>Export ACC.</th> : null}
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        data_list?.list?.map((data, index) => (
                                            <tr key={index}>
                                                <td className='fw-600'>{data.datetimestamp}</td>
                                                <td className={data.meter_connected_solar1 ? "fw-600" : "text-danger fw-600"} >{data.meter_acc_solar1}</td>
                                                <td className={data.meter_connected_solar1 ? "fw-600" : "text-danger fw-600"} >{data.meter_acc_solar1_exp}</td>
                                                {data_list?.total_meter > 1 ? <td className={data.meter_connected_solar2 ? "fw-600" : "text-danger fw-600"} >{data.meter_acc_solar2}</td> : null}
                                                {data_list?.total_meter > 1 ? <td className={data.meter_connected_solar2 ? "fw-600" : "text-danger fw-600"}>{data.meter_acc_solar2_exp}</td> : null}
                                                {data_list?.total_meter > 2 ? <td className={data.meter_connected_solar3 ? "fw-600" : "text-danger fw-600"} >{data.meter_acc_solar3}</td> : null}
                                                {data_list?.total_meter > 2 ? <td className={data.meter_connected_solar3 ? "fw-600" : "text-danger fw-600"}  >{data.meter_acc_solar3_exp}</td> : null}
                                            </tr>
                                        ))
                                    }

                                </tbody>
                            </table>

                        </div>
                    </div>

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminMeterReverse